import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ServicesService from '../../services/ServicesService';

export const serviceKeys = {
  all: ['services'],
  list: () => [...serviceKeys.all, 'list'],
  modelServices: () => [...serviceKeys.all, 'model'],
};

/**
 * Hook para listar todos os serviços
 */
export function useServices() {
  return useQuery({
    queryKey: serviceKeys.list(),
    queryFn: () => ServicesService.listService(),
    staleTime: 10 * 60 * 1000, // 10 minutos
  });
}

/**
 * Hook para buscar serviços da model
 */
export function useModelServices() {
  return useQuery({
    queryKey: serviceKeys.modelServices(),
    queryFn: () => ServicesService.getModelServices(),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Hook para salvar serviços em lote
 */
export function useUpsertModelServices() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (services) => ServicesService.upsertModelServiceBatch(services),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceKeys.modelServices() });
    },
  });
}

/**
 * Hook para deletar serviço
 */
export function useDeleteModelService() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serviceId) => ServicesService.deleteModelService(serviceId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: serviceKeys.modelServices() });
    },
  });
}
